module.exports = require("lodash.trimend");